import simulationDataDefaultValues
  from '@/domain/enums/installation/engineering/loadSimulation/loadSimulationDefaultValues';

export default {
  installation: null,
  userAccessibleInstallations: null,
  simulationData: {
    points: [],
    isInvalid: true,
    validPoints: [],
    isEmpty: true,
    interval: simulationDataDefaultValues.TIME_INTERVAL_BETWEEN_POINTS,
    isIntervalInvalid: false,
    repetitions: simulationDataDefaultValues.SIMULATION_REPETITIONS_NUMBER,
    isRepetitionsInvalid: false,
    importData: {},
  },
};
